(ns teamoesterreich.admin-mode.questionnaire.questionnaire-form
  (:require ["react-virtualized" :as rv]
            [clojure.string :as str]
            [goog.json :as json]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.data.questionnaire :as d-questionnaire]
            [teamoesterreich.admin-mode.questionnaire.questionnaire-detail-form :as questionnaire-detail-form]
            [teamoesterreich.admin-mode.questionnaire.questionnaire-question-list :as questionnaire-question-list]
            [reagent.core :as r]
            [teamoesterreich.util.log :as log]))



(defn get-it []
  (let [!st (r/atom {:tab 0})]
    (fn []
      (let [!questionnaire (r/cursor vstate/app-state [:edit-questionnaire :selected-questionnaire])
            !loaded (r/cursor vstate/app-state [:edit-questionnaire :selected-questionnaire-loaded])
            !list-loaded (r/cursor vstate/app-state [:questionnaire :questionnaire-list-state])

            !actual-user (r/cursor vstate/app-state [:actual-user])
            !tab (r/cursor vstate/app-state [:edit-questionnaire :selected-tab])
            !publish-popup-show (r/cursor !st [:publish-popup-show])
            reload-fn (fn [] (reset! !loaded false) (reset! !list-loaded {}))
            ]
        (if-not @!loaded
          (do
            (d-questionnaire/<get-questionnaire (:questionnaireQuestionnaire-uuid @!questionnaire)
                                               (fn [response]
                                                 ;(log/debug "questionnaire form " response)
                                                 (reset! !questionnaire response)
                                                 (reset! !loaded true)
                                                 ))
            [mui/card-content {}
             [:br]
             [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}]
             [mui/typography {} "Lade Daten ... "]
             ]
            )
          (do
            (log/debug "questionnaire form " @!questionnaire)
            [mui/grid
             {:container  true
              :direction  "row"
              :alignItems "stretch"
              :justify    "flex-start"
              :style {:textAlign "left" :marginBottom "50px" :marginTop "15px"}
              }
             [mui/grid
              {:container false
               :item true
               :xl 7
               :xs 12  ;extra-small: 0px
               }
              [mui/card
               [mui/card-header {:onClick reload-fn
                                 :title (str "Fragebogen `" (:questionnaireQuestionnaire-name @!questionnaire) "`")}]
               [mui/card-content {}
                (log/debug "Open Tab " @!tab)
                [mui/tabs {:value          (or @!tab 0)
                           :onChange       (fn [x i y] (log/debug "set tab " x i y) (reset! !tab i))
                           :indicatorColor "primary"
                           :textColor      "primary"
                           :variant        "scrollable"
                           }
                 [mui/tab {:value 0 :label "Details"}]
                 [mui/tab {:value 1 :label "Fragen"}]
                 (when (or (= (:tom-id @!actual-user) 1) (= (:tom-id @!actual-user) 53177)) [mui/tab {:value 99 :label (str "RAW für " (:tom-id @!actual-user) )}])
                 ]
                ;;show-absent? show-standby? show-participated?
                (case (or @!tab 0)
                  0 [questionnaire-detail-form/get-it !questionnaire !publish-popup-show reload-fn]
                  1 [(questionnaire-question-list/get-it)]

                  99 [mui/card-content {}
                      [:p "Übersicht über Fragebogen....."]
                      [:pre {:style {:textAlign "left"}} (str/replace (json/serialize (clj->js @!questionnaire)) "," ",\n")]]

                  )
                ]]]])
          )))))



